import Vue from "vue";
import App from "./App.vue";
import { store } from "./store/store";
import router from "./router";

import firebase from "firebase/app";
import "firebase/auth";
import "./firebaseInit";

import titleMixin from './mixins/titleMixin';

Vue.mixin(titleMixin);

import Transitions from "vue2-transitions";

Vue.use(Transitions);

import { BootstrapVue } from 'bootstrap-vue';
Vue.use(BootstrapVue);

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@/css/sb-admin-2.css';
import '@/css/job-eng.css';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development"


firebase.auth().onAuthStateChanged(() => {
  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount("#app");
})

